import React, { useEffect, useRef } from 'react';
import { useSystemStore } from '@/stores/systemStore';
import { logger } from '@/services/LoggingService';

export function GlobalNetworkStatus() {
  const { setOffline } = useSystemStore();
  const mountedRef = useRef(false);
  const onlineTimerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    if (mountedRef.current) return;
    mountedRef.current = true;

    const showOfflineBanner = () => {
      setOffline(true);
      logger.warn('NetworkStatus', 'Offline detected');
    };

    const dismissIfStableOnline = () => {
      // Debounce to avoid strobe on flaky networks
      if (onlineTimerRef.current) clearTimeout(onlineTimerRef.current);
      onlineTimerRef.current = setTimeout(() => {
        setOffline(false);
        logger.info('NetworkStatus', 'Back online (stable)');
        onlineTimerRef.current = null;
      }, 1500);
    };

    // Initial state
    if (typeof navigator !== 'undefined' && navigator && 'onLine' in navigator && navigator.onLine === false) {
      showOfflineBanner();
    }

    const onOffline = () => {
      if (onlineTimerRef.current) {
        clearTimeout(onlineTimerRef.current);
        onlineTimerRef.current = null;
      }
      showOfflineBanner();
    };
    const onOnline = () => dismissIfStableOnline();

    window.addEventListener('offline', onOffline);
    window.addEventListener('online', onOnline);

    return () => {
      window.removeEventListener('offline', onOffline);
      window.removeEventListener('online', onOnline);
      if (onlineTimerRef.current) clearTimeout(onlineTimerRef.current);
    };
  }, [setOffline]);

  return null;
}

export default GlobalNetworkStatus;
